import { __assign } from "tslib";
import { ATDealersLinks, ATGroupLinks } from '../footer-shared-links';
export var FooterTrucksLinks = function () {
    return [
        __assign({}, ATGroupLinks),
        {
            rowHeading: 'Private customers',
            subNav: [
                {
                    url: '/trucks/sell',
                    displayText: 'Sell my truck',
                    routerLink: false,
                },
                {
                    url: '/trucks/sell-my-truck/advertising-prices',
                    displayText: 'Advertising costs',
                    routerLink: false,
                },
                {
                    url: '/safety_and_security_centre',
                    displayText: 'Buying & selling safely online',
                    routerLink: false,
                },
                {
                    url: '/terms-and-conditions/advertising',
                    displayText: 'Terms & conditions',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Quick search',
            subNav: [
                {
                    url: '/trucks/used-trucks/browse-all-makes',
                    displayText: 'All truck makes',
                    routerLink: false,
                },
                {
                    url: '/trucks/used-trucks/type',
                    displayText: 'All truck body types',
                    routerLink: false,
                },
                {
                    url: '/trucks/used-trucks/category',
                    displayText: 'All truck categories',
                    routerLink: false,
                },
                {
                    url: '/trucks/used-trucks/uk',
                    displayText: 'All UK locations',
                    routerLink: false,
                },
                {
                    url: '/trucks/content',
                    displayText: 'Truck reviews',
                    routerLink: false,
                },
                {
                    url: '/trucks/dealer-directory',
                    displayText: 'Truck dealers',
                    routerLink: false,
                },
            ],
        },
        __assign({}, ATDealersLinks),
    ];
};
export default FooterTrucksLinks;
